export const GIFT_PASS_BUNDLES_LIST_PATH = '/admin/marketing/gift-pass-bundles';
export const NEW_GIFT_PASS_BUNDLE_PATH = `${GIFT_PASS_BUNDLES_LIST_PATH}/new`;

export function giftPassBundlePath(id: string): string {
  return `${GIFT_PASS_BUNDLES_LIST_PATH}/${encodeURIComponent(id)}`;
}
